import React from 'react'; 
import classes from './PieChart.module.css';
import { Pie } from 'react-chartjs-2'; 
import { TQ, RARITY_INFO } from '../../../shared/utility'; 
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = (props) => {
    const labels = [];
    const backgroundColor = [];
    for (const property in RARITY_INFO) {
        labels.push(property); 
        backgroundColor.push(RARITY_INFO[property][0]); 
    }
    backgroundColor[backgroundColor.length - 1] = 'black'; 

    const data = {
        labels: labels,
        datasets: [{
            backgroundColor: backgroundColor,
            data: [
                props.rarityStats.common, 
                props.rarityStats.uncommon, 
                props.rarityStats.rare, 
                props.rarityStats.epic, 
                props.rarityStats.holy, 
                props.rarityStats.godly, 
                props.rarityStats[TQ]
            ]
        }]
    };

    const options = {
        plugins: {
            legend: { display: false }
        },
        animation: { duration: 500 },
        maintainAspectRatio: false,
        elements: {
            arc: { borderWidth: 0 }
        }
    };

    return (
        props.totalSpins !== 0 
            ? 
                <div className={classes.PieChart}>
                    <Pie
                        data={data}
                        width={400}
                        height={400}
                        options={options}
                    />
                </div> 
            : <div className={classes.PieChartNullText}>Nothing to show!</div>
    );
};

export default PieChart; 
